/* eslint-disable */
import React, { FC, Fragment, useState } from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';
import Card from '../../hoc/Card';

import ProfileConfiguration from '../../containers/ProfileConfiguration';
import { FormattedDate } from 'Utils/formattedDate';
import { capitalizeString } from 'Utils/capitalizeString';

export interface SectionItemConfig {
  classes?: any;
  data?: any;
  label: string;
  dataKey: string | string[];
  hidden?: boolean;
}

export interface SectionConfig {
  classes?: any;
  data?: any;
  label: string;
  sectionItems: SectionItemConfig[];
  linebreak: boolean;
  hidden?: boolean;
}

interface Props {
  classes: any;
  data: any;
  loading?: any;
  error?: any;
  profileSections: any;
  setProfileSections: (sections: any) => void;
  configMenu: any;
  showConfigMenu: (val: any) => void;
  showToastMessage: any;
}

const AudienceProfileList: FC<Props> = props => {
  const applyValidationRules = (data: any, dataKey: string | string[]) => {
    if (typeof dataKey === 'string') {
      switch (dataKey) {
        case 'dateOfBirth':
          if (data[dataKey] !== '0001-01-01T00:00:00Z') {
            return FormattedDate(data[dataKey]);
          } else {
            return '-';
          }
        case 'dateRegistered':
          if (data[dataKey] !== '0001-01-01T00:00:00Z') {
            return FormattedDate(data[dataKey]);
          } else {
            return '-';
          }
        case 'gender':
        case 'levelOfStudy':
          return capitalizeString(data[dataKey]);
        case 'parentFirstName':
        case 'parentLastName':
        case 'parentFullName':
        case 'parentPhone':
        case 'parentEmail':
        case 'personalizationSuggestions':
        case 'personalizationPreferences':
          return data[dataKey] === 'NULL' ? '-' : data[dataKey];
        default:
          return data[dataKey];
      }
    } else {
      let completeKey = '';

      for (const key of dataKey) {
        completeKey += `${data[key]} `;
      }

      switch (dataKey[0]) {
        case 'intendedEntryTerm':
          return completeKey.toLowerCase().includes('undecided')
            ? 'Undecided'
            : capitalizeString(completeKey.trim());
        default:
          return completeKey.trim();
      }
    }
  };

  const getArrayTruthValue = (data: any, dataKey: string | string[]) => {
    for (const key of dataKey) {
      if (data[key]) {
        return true;
      }
    }

    return false;
  };

  const determineDataKeyStructure = (
    data: any,
    dataKey: string | string[],
    classes: any
  ) => {
    if (typeof dataKey === 'string') {
      if (data[dataKey]) {
        return (
          <div className={classes.sectionItemInfo}>
            {applyValidationRules(data, dataKey)}
          </div>
        );
      } else {
        return '-';
      }
    } else {
      if (getArrayTruthValue(data, dataKey)) {
        return (
          <div className={classes.sectionItemInfo}>
            {applyValidationRules(data, dataKey)}
          </div>
        );
      } else {
        return '-';
      }
    }
  };

  const Section: FC<SectionConfig> = (props: SectionConfig) =>
    !props.hidden && (
      <Fragment>
        <div className={props.classes.section}>
          <div className={props.classes.sectionHeader}>{props.label}</div>
          {props.sectionItems.map((sectionItem: any, index: number) => {
            return (
              <Fragment key={`${sectionItem.label}, ${index}`}>
                <SectionItem
                  classes={props.classes}
                  data={props.data}
                  label={sectionItem.label}
                  dataKey={sectionItem.dataKey}
                  hidden={sectionItem.hidden}
                />
              </Fragment>
            );
          })}
        </div>
        {props.linebreak && <div className={props.classes.lineBreak}></div>}
      </Fragment>
    );

  const SectionItem: FC<SectionItemConfig> = (props: SectionItemConfig) =>
    !props.hidden && (
      <>
        <div className={props.classes.sectionItem}>
          <div className={props.classes.sectionItemLabel}>{props.label}</div>
          {determineDataKeyStructure(props.data, props.dataKey, props.classes)}
        </div>
        {props.label === "Guardian's Phone Number" && (
          <div className={props.classes.lineBreak}></div>
        )}
      </>
    );

  return (
    <div className={props.classes.container}>
      <Card
        error={props.error}
        loading={props.loading}
        title="Profile"
        showCogIcon={true}
        cardConfig={
          <ProfileConfiguration
            profileSections={props.profileSections}
            setProfileSections={props.setProfileSections}
            showConfigMenu={props.showConfigMenu}
            showToastMessage={props.showToastMessage}
            visitorType={props.data.visitorType}
          />
        }
        configMenu={props.configMenu}
        showConfigMenu={props.showConfigMenu}
      >
        {props.profileSections.map((item: any, index: number) => {
          return (
            <Section
              classes={props.classes}
              data={props.data}
              label={item.label}
              sectionItems={item.sectionItems}
              hidden={item.hidden}
              key={`${item.label}, ${index}`}
              linebreak={index < props.profileSections.length - 1}
            />
          );
        })}
      </Card>
    </div>
  );
};

export default injectSheet(styleSheet)(AudienceProfileList);
